import { imagesKeys, mapImagesKeys } from '../store/store.conts'
import {
  ImageResponseType,
  ImagesKeys,
  LargeImageItemType,
} from '../types/store.types'

export const setImageUrl = (image: LargeImageItemType) => {
  image.url = //@ts-ignore
    window.SAT.config.apiUrl + `/images/getimage?imageId=${image.id}`
  return image
}

export const getPreparedImages = (images: ImageResponseType) => {
  let imgCollection = imagesKeys.map((key) => ({
    key: key as ImagesKeys,
    images: [] as LargeImageItemType[],
  }))

  Object.entries(images).forEach(([key, images]) => {
    const collectionKey = mapImagesKeys[key]
    const item = imgCollection.find((item) => item.key === collectionKey)

    if (item) {
      const newItem = {
        ...item,
        images: item.images.concat(images.map(setImageUrl)),
      }

      imgCollection = imgCollection.map((item) =>
        item.key === collectionKey ? newItem : item
      )
    }
  })

  return imgCollection.filter((el) => el.images.length)
}
